/**
 * pixi-particles — EmitterColorOp.ts
 * Ported from Phaser's `Phaser.GameObjects.Particles.EmitterColorOp`.
 *
 * A specialized EmitterOp that manages the `color` property of a Particle,
 * smoothly interpolating between an array of hex colors (e.g.
 * `[0xff0000, 0x00ff00, 0x0000ff]`) across the particle's lifetime.
 */

import { AnyParticle, EmitterOp } from './EmitterOp';
import { GetColor, IntegerToRGB } from './Utils';
import { GetEaseFunction } from './Easing';
import { GetInterpolationFunction } from './Interpolation';

export class EmitterColorOp extends EmitterOp
{
    easeName = 'Linear';

    r: number[] = [];
    g: number[] = [];
    b: number[] = [];

    constructor (key: string)
    {
        super(key, null, false);

        this.active = false;
    }

    override getMethod (): number
    {
        return (this.propertyValue === null) ? 0 : 9;
    }

    override setMethods (): this
    {
        var value = this.propertyValue as number[];
        var current: any = value;

        var onEmit: any = this.defaultEmit;
        var onUpdate: any = this.defaultUpdate;

        if (this.method === 9)
        {
            this.start = value[0];
            this.ease = GetEaseFunction('Linear');
            this.interpolation = GetInterpolationFunction('linear');

            onEmit = this.easedValueEmit;
            onUpdate = this.easeValueUpdate;
            current = value[0];

            this.active = true;

            this.r.length = 0;
            this.g.length = 0;
            this.b.length = 0;

            for (var i = 0; i < value.length; i++)
            {
                var color = IntegerToRGB(value[i]);

                this.r.push(color.r);
                this.g.push(color.g);
                this.b.push(color.b);
            }
        }

        this.onEmit = onEmit.bind(this);
        this.onUpdate = onUpdate.bind(this);
        this.current = current;

        return this;
    }

    setEase (value: string): void
    {
        this.easeName = value;
        this.ease = GetEaseFunction(value);
    }

    protected override easedValueEmit (): any
    {
        this.current = this.start;

        return this.start;
    }

    protected override easeValueUpdate (_particle: AnyParticle, _key: string, t: number): number
    {
        var v = this.ease!(t);

        var r = this.interpolation!(this.r, v);
        var g = this.interpolation!(this.g, v);
        var b = this.interpolation!(this.b, v);

        var current = GetColor(r, g, b);

        this.current = current;

        return current;
    }
}

export default EmitterColorOp;
